module.exports = __webpack_public_path__ + "static/media/suscripcionesaltasbajas.7d0bc455.svg";